import { combineLatest, filter, take, tap } from "rxjs";

import { _T } from "@rfice/language";

import SingleTonFirebaseServiceController from "@/frameworks/core/firebase/controller/FirebaseServiceController";
import { Configure, Properties, Utility } from "@/frameworks/libraries";
import { DeviceService } from "@/frameworks/core/API";
import { SystemError } from "@/frameworks/core/commons";
import { usePersistActions } from "@/frameworks/core/persistence";
import NavigationService from "@/frameworks/core/system/Router/NavigationService";
import WSNetworkServiceObserver from "./WSNetworkObserver";

const LOGTAG = "ServiceInitalizer";

class ServiceInitalizer {
	private static _instance: ServiceInitalizer | null = null;
	constructor() {
		this._addEvents();
	}
	public static getInstance(): ServiceInitalizer {
		return this._instance || (this._instance = new this());
	}

	public activate() {
		SingleTonFirebaseServiceController.getInstance().activate();
	}

	private _addEvents() {
		this.browserAvailable();
		this.readyUserDevice();
		this.observeNetworkStatus();
	}

	/**
	 * 브라우저 버전 확인
	 */
	private browserAvailable() {
		if (Utility.isSafari && Utility.safariVersion < 18) {
			throw new SystemError(_T("지원하지 않는 버전입니다. 사파리 업데이트 바랍니다."), {
				cause: {
					errorCode: "80211",
					errorMessage: "지원하지 않는 브라우저입니다."
				}
			});
		}
	}

	/**
	 * 네트워크 상태 관찰로 유효할 경우 정보 업데이트
	 */
	private observeNetworkStatus() {
		WSNetworkServiceObserver.getInstance().status$.subscribe((status) => {
			// console.log(LOGTAG, "networkStatus:", status);
			if (status === "fullfiled") {
				usePersistActions().users.update_me(null);
			}
		});
	}
	/**
	 //BE에서 fcm key 등록 api 호출 시점을 로그인 후 stomp 연결 한 후 전달 요청
	 */
	private readyUserDevice() {
		console.log(this.constructor.name, "addEvents");
		combineLatest([
			SingleTonFirebaseServiceController.getInstance().status$,
			WSNetworkServiceObserver.getInstance().status$
		])
			.pipe(
				tap(([fireBasestatus, networkStatus]) => {
					console.log(LOGTAG, "fireBasestatus:", fireBasestatus, "networkStatus:", networkStatus);
				}),
				filter(
					([fireBasestatus, networkStatus]) => fireBasestatus === "fullfiled" && networkStatus === "fullfiled"
				),
				take(1)
			)
			.subscribe(() => {
				console.log(LOGTAG, "ServiceInitalizer request event");
				new DeviceService({}).device.update
					.execute({
						deviceKey: Properties.browserTabID,
						fcmKey: SingleTonFirebaseServiceController.getInstance().clientToken ?? undefined,
						language: Configure.useLanguage
					})
					.then((result: ReturnDataType<WebServices.Device.Update.Data>) => {
						const success = result.status === 200;
						console[success ? "debug" : "warn"](
							LOGTAG,
							"Device information",
							success ? "updated" : "update failed"
						);
					})
					.catch((error) => {
						console.error(LOGTAG, "Device information update exception with", error);
						Configure.clear_authenticated();
						new SystemError(_T("장치 등록에 실패하였습니다."), {
							cause: {
								errorCode: "111111",
								errorMessage: "장치 등록에 실패하였습니다."
							}
						});
						NavigationService.go("/", { state: null });
					});
			});
	}
}

export default ServiceInitalizer;
